<template>
  <div id="pageRoot">
    <p class="textBase appearAnimationB" id="text01">
      Presta atención a los siguientes enunciados.
    </p>
    <p class="textBase appearAnimationB" id="text02">
      Presta atención a las expresiones destacadas.
    </p>
    <p class="textBase appearAnimationB" id="text03">
      Marca la opción correcta.
    </p>
    <p class="textBase appearAnimationB" id="text04">
      Los lobos ayudaban a los humanos
    </p>

    <div class="hover-animation-c appearAnimationA" id="tag01">
      <p class="textBase" id="tag01Text">a seguir el rastro de</p>
    </div>

    <div class="hover-animation-c appearAnimationA" id="tag02">
      <p class="textBase" id="tag02Text">los animales salvajes.</p>
    </div>

    <p class="textBase appearAnimationB" id="text07">Es lo mismo que decir:</p>

    <label
      class="toggleButtonContainer pageElement"
      id="toggle01"
      style="width: 360px"
      >Los lobos ayudaban a los humanos<br />a ahuyentar a los animales
      salvajes.
      <input
        type="radio"
        name="pregunta"
        ref="1-1"
        v-on:change="saveOption('radios', 1, 1)"
        :onload="loadOption('radios', 1, 1)"
      />
      <span class="toggleButton"></span>
    </label>
    <label
      class="toggleButtonContainer pageElement"
      id="toggle02"
      style="width: 360px"
      >Los lobos ayudaban a los humanos<br />a perseguir a los animales.
      <input
        type="radio"
        name="pregunta"
        ref="1-2"
        v-on:change="saveOption('radios', 1, 2)"
        :onload="loadOption('radios', 1, 2)"
      />
      <span class="toggleButton"></span>
    </label>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <div class="pageElement" id="fixed"></div>
    <span class="footer-page footer-listen"></span>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
#fixed {
  position: absolute;
  width: 791.66px;
  height: 196.97px;
  left: 36px;
  top: 50px;
  background-image: url(/pages/img/sordo/svgPage86FixedBackground.svg);
}
#text01 {
  position: absolute;
  width: 594px;
  height: 35px;
  left: 78px;
  top: 118px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text02 {
  position: absolute;
  width: 594px;
  height: 35px;
  left: 78px;
  top: 168px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text03 {
  position: absolute;
  width: 308px;
  height: 35px;
  left: 78px;
  top: 218px;

  font-size: 24px;
  line-height: 33px;

  color: #000000;
}
#text04 {
  position: absolute;
  width: 560px;
  height: 43px;
  left: 78px;
  top: 278px;

  font-style: italic;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #000000;
}
#tag01 {
  position: absolute;
  width: 344px;
  height: 49px;
  left: 621px;
  top: 282px;
  background-color: #00a5a5;
}
#tag01Text {
  position: absolute;
  width: 315px;
  height: 39px;
  left: 18px;
  top: 0px;

  font-style: italic;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #fdfafa;
}
#tag02 {
  position: absolute;
  width: 344px;
  height: 49px;
  left: 70px;
  top: 321px;
  background-color: #00a5a5;
}
#tag02Text {
  position: absolute;
  width: 330px;
  height: 41px;
  left: 8px;
  top: 4px;

  font-style: italic;
  font-weight: normal;
  font-size: 33px;
  line-height: 45px;

  color: #fdfafa;
}
#text07 {
  position: absolute;
  width: 328px;
  height: 33px;
  left: 39px;
  top: 395px;

  font-size: 30px;
  line-height: 41px;

  color: #00a5a5;
}
#toggle01 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 372px;
  top: 396.86px;
  line-height: 37px;
}
#toggle02 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 372px;
  top: 514.86px;
  line-height: 37px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p89/V117.mp4",
        "p89/V118.mp4",
        "p89/V119.mp4",
        "p89/V120.mp4",
        "p89/V121.mp4",
      ],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>